import { useEffect } from "react";
import useAuth from "@/hooks/useAuth";
// import { axiosPrivate } from "@/apiCalls/axios";
import useRefreshToken from "@/context/UseRefreshToken";
import { axiosPrivateFile } from "@/apiCalls/axios";


const useAxiosPrivateFile = () => {
    const refresh = useRefreshToken();
    const { auth } = useAuth();

    useEffect(() => {

        const requestIntercept = axiosPrivateFile.interceptors.request.use(
            (config: any) => {
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${auth?.accessToken}`;
                }
                return config
            }, (error: any) => Promise.reject(error)
        );

        const responseIntercept = axiosPrivateFile.interceptors.response.use(
            (response: any) => response,
            async (error: any) => {
                const prevRequest = error?.config;
                if (error?.response?.status === 403 && !prevRequest?.sent) {
                    prevRequest.sent = true;
                    const newAccessToken = await refresh();
                    prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`
                    return axiosPrivateFile(prevRequest);
                }
                return Promise.reject(error)
            }
        );

        return () => {
            axiosPrivateFile.interceptors.request.eject(requestIntercept)
            axiosPrivateFile.interceptors.response.eject(responseIntercept)
        }
    }, [auth, refresh])

    return axiosPrivateFile
}

export default useAxiosPrivateFile